import { CollectionCard } from "../../Products/CollectionCard/CollectionCard";
import { NftCard } from "../../Products/NftCard/NftCard";
import { SingleCollectionContentMain } from "../../SingleCollection/SingleCollectionContent/SingleCollectionContent.styled";
import NoItems from "../../../assets/img/NoItems.svg";
import { addEmptyBlocksProfile } from "../../../utils/addEmptyBlocks";

export const UserMainContent = ({ products, collection = false }) => {
  return (
    <SingleCollectionContentMain>
      {products.length > 0 ? (
        <>
          {products.map((product, i) => (collection ? <CollectionCard product={product} key={i} /> : <NftCard product={product} key={i} />))}

          {addEmptyBlocksProfile(products.length)}
        </>
      ) : (
        <img src={NoItems} style={{ margin: "100px auto" }} alt='No Items' />
      )}
    </SingleCollectionContentMain>
  );
};
